import { QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import React from 'react'
import { I18nProvider } from 'react-aria-components'
import { useTranslation } from 'react-i18next'

import { queryClient } from '#/api/queryClient'
import { EnvironmentRibbon } from '#components/EnvironmentRibbon'

import { routeTree } from './routeTree.gen'

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
  defaultViewTransition: true,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Register {
    router: typeof router
  }
}

export const App = (): React.JSX.Element => {
  const { i18n } = useTranslation()

  return (
    <I18nProvider locale={i18n.language}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <EnvironmentRibbon />
      </QueryClientProvider>
    </I18nProvider>
  )
}
